import React, { useState, useEffect } from 'react';
import PropertyLocationMap from '../shared/PropertyLocationMap';
import ListingAgentProfileCard from '../agent/ListingAgentProfileCard';
import { getPropertyCardImage, resolveListingAgentFields, hasListingAgent } from '../../utils/properties';

const ListingsMapBrowse = ({ properties, onSelectProperty, onContactAgent, country }) => {
  const [selectedId, setSelectedId] = useState(properties[0]?.id || null);
  useEffect(() => {
    if (!properties.length) {
      setSelectedId(null);
      return;
    }
    if (!properties.some((p) => p.id === selectedId)) {
      setSelectedId(properties[0].id);
    }
  }, [properties, selectedId]);
  const selected = properties.find((p) => p.id === selectedId) || properties[0];
  const selectedAgent = selected ? resolveListingAgentFields(selected) : null;
  if (!properties.length) return null;
  return (
    <div className="listings-map-browse">
      <div className="listings-map-browse-list" role="listbox" aria-label="Listings on map">
        {properties.map((p) => {
          const thumb = getPropertyCardImage(p);
          return (
            <button
              key={p.id}
              type="button"
              role="option"
              aria-selected={p.id === selected?.id}
              className={`listings-map-browse-item${p.id === selected?.id ? " active" : ""}`}
              onClick={() => setSelectedId(p.id)}
              onDoubleClick={() => onSelectProperty?.(p)}
            >
              <div className="listings-map-browse-item-inner">
                {thumb ? (
                  <img className="listings-map-browse-item-thumb" src={thumb} alt="" loading="lazy" />
                ) : (
                  <div className="listings-map-browse-item-thumb listings-map-browse-item-thumb--empty" aria-hidden="true">
                    <i className="fas fa-home"></i>
                  </div>
                )}
                <div className="listings-map-browse-item-copy">
                  <strong>{p.title}</strong>
                  <span>
                    <i className="fas fa-map-marker-alt" aria-hidden="true"></i> {p.location}
                  </span>
                </div>
              </div>
            </button>
          );
        })}
      </div>
      {selected && (
        <div className="listings-map-browse-panel">
          <div className="listings-map-browse-map-wrap">
            <PropertyLocationMap
              location={selected.location}
              title={selected.title}
              fill
              showHeader
            />
          </div>
          {hasListingAgent(selectedAgent) && onContactAgent ? (
            <ListingAgentProfileCard
              property={selectedAgent}
              onMessage={onContactAgent}
              compact
            />
          ) : null}
          <button
            type="button"
            className="btn btn-primary btn-sm"
            style={{ width: "100%" }}
            onClick={() => onSelectProperty?.(selected)}
          >
            View listing details
          </button>
        </div>
      )}
    </div>
  );
};

export default ListingsMapBrowse;
